
  import { Component,Vue } from 'vue-property-decorator'
	import { Action } from 'vuex-class'
  @Component
  export default class Login extends Vue {
    username:string = ''
    password:string = ''
    form:any = {
      username: '',
      password: ''
    }
    logining:boolean = false
    rules:object = {
      username: {required: true, message: '请填写手机号码',trigger: 'blur'},
      password: {required: true, message: '请填写密码',trigger: 'blur'}
    }
		@Action('login') login:any
		@Action('initData') getBaseInfo:any
    async submitForm(){
      if(this.form.username !== '' && this.form.password !== ''){
        this.logining = true
        try{
          const res = await this.login(this.form)
          if(res.access_token){
				window.localStorage.setItem('token',res.access_token);
				this.$message.success('登录成功');
				await this.getBaseInfo()
            this.$router.replace('/');
          }
          console.log(res);
        }catch(err){
          this.$message.error('登录错误，请联系管理员');
        }
        this.logining = false;
      }else{
        this.$message.error('用户名或密码错误');
      }
    }
  }
